import React from 'react';
import { Helmet } from 'react-helmet-async';
import './LegalPages.css';

const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - One Piece Trivia</title>
        <meta name="description" content="Privacy Policy for One Piece Trivia. Learn how we collect, use, and protect your information." />
        <link rel="canonical" href="https://www.onepiecetrivia.com/privacy" />
      </Helmet>

      <div className="legal-page-container">
        <div className="legal-page-content">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last Updated: December 28, 2025</p>

          <section>
            <h2>Introduction</h2>
            <p>
              Welcome to One Piece Trivia ("we," "our," or "us"). We respect your privacy and are
              committed to protecting your personal data. This privacy policy explains how we collect,
              use, and safeguard your information when you visit our website onepiecetrivia.com.
            </p>
          </section>

          <section>
            <h2>Information We Collect</h2>
            <h3>Automatically Collected Information</h3>
            <p>When you visit our website, we may automatically collect:</p>
            <ul>
              <li>IP address and general location data</li>
              <li>Browser type and version</li>
              <li>Device type and operating system</li>
              <li>Pages visited and time spent on pages</li>
              <li>Referring website addresses</li>
              <li>Game scores and quiz performance (stored locally)</li>
            </ul>

            <h3>Cookies and Tracking Technologies</h3>
            <p>
              We use cookies and similar tracking technologies to enhance your experience.
              These include:
            </p>
            <ul>
              <li><strong>Essential Cookies:</strong> Required for the website to function properly</li>
              <li><strong>Analytics Cookies:</strong> Help us understand how visitors use our site (Google Analytics)</li>
              <li><strong>Advertising Cookies:</strong> Used by Google AdSense to display relevant ads</li>
            </ul>
          </section>

          <section>
            <h2>How We Use Your Information</h2>
            <p>We use the collected information to:</p>
            <ul>
              <li>Provide and maintain our quiz games</li>
              <li>Improve user experience and website performance</li>
              <li>Analyze usage patterns and trends</li>
              <li>Display relevant advertisements through Google AdSense</li>
              <li>Prevent fraud and ensure security</li>
            </ul>
          </section>

          <section>
            <h2>Third-Party Services</h2>
            <p>We use the following third-party services:</p>
            <ul>
              <li><strong>Google Analytics:</strong> For website traffic analysis</li>
              <li><strong>Google AdSense:</strong> For displaying advertisements</li>
              <li><strong>Google Tag Manager:</strong> For managing tracking scripts</li>
            </ul>
            <p>
              These services may collect information about your browsing behavior.
              Please review their respective privacy policies for more information.
            </p>
          </section>

          <section>
            <h2>Data Storage</h2>
            <p>
              Game scores and preferences are stored locally in your browser using localStorage.
              This data remains on your device and is not transmitted to our servers unless you
              create an account (optional feature).
            </p>
          </section>

          <section>
            <h2>Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access the personal data we hold about you</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Opt-out of marketing communications</li>
              <li>Disable cookies through your browser settings</li>
            </ul>
          </section>

          <section>
            <h2>Children's Privacy</h2>
            <p>
              Our website is intended for general audiences. We do not knowingly collect
              personal information from children under 13. If you believe we have collected
              information from a child, please contact us immediately.
            </p>
          </section>

          <section>
            <h2>Changes to This Policy</h2>
            <p>
              We may update this privacy policy from time to time. We will notify you of any
              changes by posting the new policy on this page and updating the "Last Updated" date.
            </p>
          </section>

          <section>
            <h2>Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy, please contact us at:
            </p>
            <p className="contact-email">chibidashofficial@gmail.com</p>          </section>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
